export default __webpack_public_path__ + "static/agc-8c40ea5f55d6aa15be43763e17b1bd8e.png";